/*
* 销课详情
*/
<template>
    <div>
        <van-nav-bar placeholder title="销课详情" left-text="" left-arrow @click-left="onClickLeft()">
            <template #right>
            </template>
        </van-nav-bar>
        <van-pull-refresh v-model="loading" @refresh="refresh()" style="min-height: 100vh">
            <van-form @submit="onSubmit">
                <div class="yj-box">
                    <div class="box-title">
                        <h2>销课信息</h2>
                        <!--<img src="~@/assets/xl.png">-->
                    </div>
                    <div class="yj-con">
                        <div class="con-list"><span>机构名称：</span><p>{{ record.institutionName }}</p></div>
                        <div class="con-list"><span>课程名称：</span><p>{{ record.curriculumName }}</p></div>
                        <div class="con-list"><span>任课教师：</span><p>{{ record.teacherName }}</p></div>
                        <van-field
                                required
                                readonly
                                label="实际上课时间"
                                v-model="signTime"
                                @click="show = true"
                                :rules="[{ required: true, message: '请选择实际上课时间!' }]"
                        />
                        <van-action-sheet v-model="show" title="实际上课时间">
                            <van-datetime-picker
                                    v-model="currentDate"
                                    type="datetime"
                                    @cancel="show = false"
                                    @confirm="onConfirm"
                            />
                        </van-action-sheet>
                    </div>
                </div>
                <div  class="yj-box">
                    <div  class="box-title">
                        <h2>学员列表</h2>
                        <!--<img src="~@/assets/xl.png">-->
                    </div>
                    <div class="yj-con">
                        <div class="con-list" v-for="item in applyInfoList" :key="item.id">
                            <span>{{ item.studentName }}</span>
                            <span>{{ item.phone }}</span>
                            <span v-show="item.classHour">{{ item.classHour }}课时</span>
                            <van-stepper v-model="item.consumerClass" min="0" :max="item.leftHour" theme="round" button-size="22" />
                        </div>
                    </div>
                </div>
                <div style="margin: 16px;">
                    <van-button
                            :loading="submitLoading"
                            v-if="applyInfoList.length > 0"
                            round block type="primary"
                            native-type="submit">
                        保存
                    </van-button>
                </div>
            </van-form>
        </van-pull-refresh>
    </div>
</template>

<script>
    import {queryDetailInfo, signAdd} from '@/api/course/institutionCourse'
    import {confirmClasses} from "../../api/course/course";
    import {formatDate} from '@/js/common/common'

    export default {
        name: 'DisputeList',
        components: {
        },
        data () {
            return {
                signTime: '',
                currentDate: new Date(),
                loading: false,
                show: false,
                submitLoading: false,
                id: '',
                record: {},
                applyInfoList: []
            }
        },
        computed: {
        },
        created () {
            this.id = this.$route.query.id;
            this.refresh()
        },
        mounted () {
        },
        methods: {
            refresh() {
                this.getDetail()
            },
            onConfirm(date) {
                // console.log("shijian ", date);
                this.show = false;
                this.signTime = formatDate(date);
            },
            getDetail() {
                queryDetailInfo({ curriculumId: this.id }).then(res => {
                    if (res.code === 10000) {
                        this.record = res.result || {};
                        this.applyInfoList = this.record.applyInfoList || []
                    }
                }).finally(() => {
                    setTimeout(() => {
                        this.loading = false
                    }, 100)
                })
            },
            onClickLeft() {
                this.$router.go(-1)
            },
            onSubmit(){
                this.submitLoading = true;
                if (this.applyInfoList.length < 1){
                    this.$toast("学生列表无数据!");
                    return
                }
                const data = {
                    curriculumId: this.id,
                    signInfoList: this.applyInfoList,
                    signTime: this.signTime
                };
                console.log("参数", data);
                signAdd(data).then(res => {
                    if (res.code === 10000) {
                      (res.result || []).forEach(k => {
                        confirmClasses({id: k})
                      })
                      this.$toast(res.msg);
                      this.$router.push({path: `/institutionCourse`});
                    }
                }).finally(() => {
                    this.submitLoading = false;
                })
            }
        }
    }


</script>

<style scoped>
    .yj-box{
        display: flex;
        margin: 0 10px;
        flex-direction: column;
    }
    .box-title{
        display: flex;
        align-items: center;
        justify-content: space-between;
        height:16px;
        margin-top: 23px;
        margin-bottom: 17px;
    }
    .box-title h2{
        display: flex;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #000000;
    }
    .box-title img{
        width: 16px;
        height: 9px;
    }
    .yj-con{
        background: #F4F5F7;
        border-radius:12px;
        display: flex;
        padding: 17px;
        flex-direction: column;
    }
    .con-list{
        display: flex;
        margin-bottom: 15px;
    }
    .con-list:last-child{
        margin-bottom: 0;
    }
    .con-list span{
        display: flex;
        font-size:14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #777777;
        width:75px;
        justify-content: flex-end;
        padding-right: 5px;
    }
    .con-list p{
        display: flex;
        flex: 1;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
    }
    /deep/.van-uploader__preview-image{
        height: 15vw;
        width:73px;
    }
    .box-style{
        padding-bottom: 20px;
    }

    /deep/.van-stepper--round .van-stepper__minus {
        color: #66C779;
        background-color: #fff;
        border: 1px solid #66C779;
    }
    /deep/.van-stepper--round .van-stepper__plus {
        color: #fff;
        background-color: #66C779;
    }
</style>
